import PropTypes from 'prop-types';

export const SURVEYS__CREATE = 'SURVEYS__CREATE';
export const SURVEYS__COPY = 'SURVEYS__COPY';
export const SURVEYS__DELETE = 'SURVEYS__DELETE';
export const SURVEYS__GET = 'SURVEYS__GET';
export const SURVEYS__GET_TAGGED = 'SURVEYS__GET_TAGGED';
export const SURVEYS__FETCH = 'SURVEYS__FETCH';
export const SURVEYS__FETCH_ACTIVE = 'SURVEYS__FETCH_ACTIVE';
export const SURVEYS__FETCH_FRAUD_DETECTION_SETTINGS = 'SURVEYS__FETCH_FRAUD_DETECTION_SETTINGS';
export const SURVEYS__FETCH_HASH = 'SURVEYS__FETCH_HASH';
export const SURVEYS__FETCH_RECENT = 'SURVEYS__FETCH_RECENT';
export const SURVEYS__MOVE = 'SURVEYS__MOVE';
export const SURVEYS__PATCH = 'SURVEYS__PATCH';
export const SURVEYS__PUBLISH = 'SURVEYS__PUBLISH';
export const SURVEYS__UPDATE = 'SURVEYS__UPDATE';
export const SURVEYS__UPDATE_ACTION = 'SURVEYS__UPDATE_ACTION';
export const SURVEYS__UPDATE_ACTION__REVIEW = 'SURVEYS__UPDATE_ACTION__REVIEW';
export const SURVEYS__UPDATE_ACTION__PUBLISH = 'SURVEYS__UPDATE_ACTION__PUBLISH';
export const SURVEYS__UPDATE_FRAUD_DETECTION_SETTINGS = 'SURVEYS__UPDATE_FRAUD_DETECTION_SETTINGS';

export const SURVEYS_REVERSE_LOOKUP__FETCH = 'SURVEYS_REVERSE_LOOKUP__FETCH';
export const SURVEYS__RESET = 'SURVEYS__RESET';

export const SURVEYS__VERSION_ALL = 'All';
export const SURVEYS__VERSION_PREVIEW = 'Preview';

export const SURVEYS__SHAPE__FRAUD_DETECTION_SETTINGS = PropTypes.shape({
  label: PropTypes.string,
  id: PropTypes.string,
  setting: PropTypes.string,
});
export const SURVEYS__SHAPE__FRAUD_DETECTION_SETTINGS_ARRAY = PropTypes.arrayOf(
  SURVEYS__SHAPE__FRAUD_DETECTION_SETTINGS,
);
export const SURVEYS__SHAPE_ITEM = PropTypes.shape({
  accessToken: PropTypes.string,
  completedCount: PropTypes.number,
  createdAt: PropTypes.number,
  createdBy: PropTypes.shape({
    email: PropTypes.string,
    firstName: PropTypes.string,
    id: PropTypes.string,
    lastName: PropTypes.string,
    timeZone: PropTypes.string,
  }),
  description: PropTypes.string,
  entryCount: PropTypes.number,
  expireAt: PropTypes.string,
  facebookPixel: PropTypes.string,
  giftbitMaxFundsInDollars: PropTypes.number,
  id: PropTypes.string,
  latestVersion: PropTypes.number,
  organizationId: PropTypes.string,
  participantLimit: PropTypes.number,
  participantLimitReachedCopy: PropTypes.string,
  publishedAt: PropTypes.number,
  rewardCount: PropTypes.number,
  rewardIpBlocking: PropTypes.bool,
  status: PropTypes.string,
  terminatedCount: PropTypes.number,
  thankYouCopy: PropTypes.string,
  resultIpBlocking: PropTypes.bool,
  blockParticipantsWithSameName: PropTypes.bool,
  theme: PropTypes.string,
  title: PropTypes.string,
  fraudDetectionSettings: SURVEYS__SHAPE__FRAUD_DETECTION_SETTINGS_ARRAY,
});

export const SURVEYS__SHAPE_ARRAY = PropTypes.arrayOf(SURVEYS__SHAPE_ITEM);

export const SURVEYS__SHAPE_VARIABLE = PropTypes.shape({
  dataType: PropTypes.string,
  name: PropTypes.string,
  validationType: PropTypes.string,
});
export const SURVEYS__SHAPE_VARIABLES_ARRAY = PropTypes.arrayOf(SURVEYS__SHAPE_VARIABLE);
